import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import CreatableSelect from 'react-select/creatable'
import toast from 'react-toastify'
import { SimpleFetch, store } from '../../../../_helpers'
import { Loader, ContentLoader } from '../../../../_components'

export default function Abandon(props) {
  const [ categories, setCategories ] = useState([])
  const [ loading, setLoading ] = useState(true)

  useEffect(() => {
    async function requestAvailableCategories() {
      const req = await SimpleFetch(`GET`, {}, {}, `momentum`, `person/event/${store.getState().changeDomainReducer.selectedDomain.domain_uuid}`);
      if ( req.status !== 200 ) {
        return toast.error("Ocorreu um erro ao listar as categorias disponíveis. Tente novamente mais tarde.", { position: toast.POSITION.TOP_RIGHT, className: 'toast-error' });
      }

      if ( req.data || req.data.length !== 0 ) {
        const arr = props.localData.trigger ? props.localData.trigger : []
        props.setLocalData({...props.localData, trigger: {...arr, "comparation": "contain"}})
      }

      setCategories(req.data.map(a => {return {label: a.parent_category, value: a.uuid}}))
      setLoading(false)
    }

    requestAvailableCategories();
  }, []);

  const handleCategoryChange = async (e, key) => {
    const arr = props.localData.trigger ? props.localData.trigger : [];
    
    if ( !e )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: ""}})

    props.setLocalData({...props.localData, trigger: {...arr, [key]: e.label}})
  }

  const handleChange = async (e, key) => {
    if ( !e || !e.value ) return

    const arr = props.localData.trigger ? props.localData.trigger : []
    
    if ( key !== "interval" )
      return props.setLocalData({...props.localData, trigger: {...arr, [key]: e.value}})

    const toSeconds = {
      "A": 31536000,
      "M": 2592000,
      "D": 86400,
      "h": 3600,
      "m": 60,
      "s": 1
    }

    const values = e.value.split(' ')
    const parsedValues = values.map(value => {
      let regex = value.match(/[a-z]+|[^a-z]+/gi)
      if ( !regex ) return 0
      
      let regexedValue = regex[0]
      let multiplier = toSeconds[regex[1]]
      let totalSeconds = multiplier * regexedValue

      if ( isNaN(totalSeconds) ) return 0
      return totalSeconds
    });

    const value = parsedValues.reduce((a, b) => a + b, 0).toString()
    return props.setLocalData({...props.localData, trigger: {...arr, [key]: value}})
  }

  return (
    <>
      {
        !loading || categories.length !== 0 ? 
          <>
            <div className="flex__break"></div>
            <Select
              options={[
                {label: "Contém", value: "contain"},
              ]}
              className="selectable selectable__disabled"
              placeholder="Selecione"
              onChange={(e) => handleChange(e, "comparation")}
              defaultValue={{label: "Contém", value: "contain"}}
              isDisabled
            />
            <CreatableSelect
              className="selectable"
              options={categories}
              isClearable
              onChange={(e) => handleCategoryChange(e, "parentCategory")}
              placeholder="Defina o gatilho a conter como condição primária"
            />
            <div className="flex__break"></div>
            <Select
              options={[
                {label: "Contém", value: "contain"},
                {label: "Não contém", value: "notcontain"}
              ]}
              className="selectable"
              placeholder="Defina a condição do segundo gatilho"
              onChange={(e) => handleChange(e, "comparation2")}
            />
            <Select
              options={categories}
              className="selectable"
              placeholder="Defina o gatilho da condição secundária"
              onChange={(e) => handleCategoryChange(e, "parentCategory2")}
            />
          </>
        : <>
          <div className="flex__break"></div>
          <div className="w-full">
            <div className="flex">
              <ContentLoader height="50px" spaceBetween={true}/>
              <ContentLoader height="50px" spaceBetween={true}/>
            </div>
            <div className="flex__break"></div>
            <div className="flex">
              <ContentLoader height="50px" spaceBetween={true}/>
              <ContentLoader height="50px" spaceBetween={true}/>
            </div>
          </div>
        </>
      }
    </>
  )
}